<template>
  <div class="check-item-container">
    <div class="input-container">
      <input
        ref="checkItem"
        type="checkbox"
        :name="'radio-' + $parent._uid"
        :id="'option-' + _uid"
        @change="$emit('input', $event.target.checked)"
        :value="value"
        :checked="checked"
      />
      <svg
        version="1.1"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
        style="enable-background:new 0 0 512 512;"
        xml:space="preserve"
      >
        <polygon
          style="fill:#004481;"
          points="202.624,478.016 0,291.36 70.512,214.8 191.968,326.656 431.44,33.984 512,99.904 "
        />
      </svg>
    </div>

    <p v-if="$slots.default"><slot /></p>
  </div>
</template>

<script>
export default {
  name: "CheckItem",
  props: ["value"],
  computed: {
    checked() {
      return this.value ? "checked" : "";
    }
  }
};
</script>

<style scoped>
.check-item-container {
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  font-weight: 300;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
}
div.input-container {
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  flex: 0;
}

input[type="checkbox"] {
  -moz-appearance: none;
  appearance: none;
  /* create custom radiobutton appearance */
  display: inline-block;
  width: 24px;
  height: 24px;
  padding: 5px;
  /* background-color only for content */
  background-clip: content-box;
  margin: 0;
  margin-right: 8px;
  cursor: pointer;
  background-color: #ffffff;
  border: solid 1px #666666;
}

svg {
  display: block;
  position: absolute;
  left: 4px;
  top: 4px;
  width: 16px;
  height: 16px;
  pointer-events: none;
  opacity: 0;
  transform: scale(0);
  transition: all 0.2s ease-out;
}

/* appearance for checked radiobutton */
input[type="checkbox"]:focus {
  outline: none;
}

input[type="checkbox"]:checked + svg {
  opacity: 1;
  transform: scale(1);
}
</style>
